import { ProjectsBatchDefinitionsListAPI } from 'ducks/types/api-types';
import { Query } from 'ducks/types/query-types';
import { normalizeBatchDefinition } from 'ducks/utils';

export function normalizeBatchDefinitions(data: ProjectsBatchDefinitionsListAPI[]) {
  return data.map((definition) => normalizeBatchDefinition(definition)).sortObject('batch_definition_name', 'asc');
}

export const getBatchDefinitionsPostData = (data?: Query) => {
  return {
    created_by: data?.created_by || '',
    max_rows: data?.max_rows || 100,
    filter: data?.filter || '',
    include_archived: data?.include_archived || false,
    parameter_name: data?.parameter_name || '',
    parameter_value: data?.parameter_value || '',
  };
};
